
import { creditNoteColNm } from "constants/creditNoteConstant";
import { invoiceColNm } from "constants/invoiceConstant";
import {  subcontractInvoiceColNm } from "constants/subcontractConstant";
import dayjs from "dayjs";
import { numberFormat } from "utils"

export const cSmileColumns = [
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: 'center',
  },
  {
    field: "CusSNm",
    headerName: "ลูกค้า",
    flex: 1,
  },
  {
    field: "InvNo",
    headerName: invoiceColNm.InvNo,
    flex: 1,
  },
  {
    field: "InvDte",
    headerName: invoiceColNm.InvDte,
    width: 100,
    type: "date",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "OwnRcptAmnt",
    headerName: "ใบเสร็จบริษัท",
    width: 80,
    align: "right",
    valueFormatter: ({ value }) => value != null ? numberFormat(value) : "-",
  },
  {
    field: "CusRcptAmnt",
    headerName: "ใบเสร็จลูกค้า",
    width: 80,
    align: "right",
    valueFormatter: ({ value }) => value != null ? numberFormat(value) : "-",
  },
  {
    field: "Total",
    headerName: "ยอดรวม",
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value != null ? numberFormat(value) : "-",
  },
]

export const cSmileColumnsSc = [
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: 'center',
  },
  {
    field: "ScSNm",
    headerName: "รถร่วม",
    flex: 1,
  },
  {
    field: "XpssDocNum",
    headerName: subcontractInvoiceColNm.XpssDocNum,
    flex: 1,
  },
  {
    field: "XpssDocDte",
    headerName: subcontractInvoiceColNm.XpssDocDte,
    width: 100,
    type: "date",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "OwnRcptAmnt",
    headerName: "ใบเสร็จบริษัท",
    width: 80,
    align: "right",
    valueFormatter: ({ value }) => value != null ? numberFormat(value) : "-",
  },
  {
    field: "CusRcptAmnt",
    headerName: "ใบเสร็จลูกค้า",
    width: 80,
    align: "right",
    valueFormatter: ({ value }) => value != null ? numberFormat(value) : "-",
  },
  {
    field: "Total",
    headerName: "ยอดรวม",
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value != null ? numberFormat(value) : "-",
  },
]


export const cSmileColumnsCN = [
  {
    field: "No",
    headerName: "No.",
    width: 40,
    align: 'center',
  },
  {
    field: "CusSNm",
    headerName: "ลูกค้า",
    flex: 1,
  },
  {
    field: "CNNo",
    headerName: creditNoteColNm.CNNo,
    flex: 1,
  },
  {
    field: "CNDte",
    headerName: creditNoteColNm.CNDte,
    width: 100,
    type: "date",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "OwnRcptAmnt",
    headerName: "ใบเสร็จบริษัท",
    width: 80,
    align: "right",
    valueFormatter: ({ value }) => value != null ? numberFormat(value) : "-",
  },
  {
    field: "CusRcptAmnt",
    headerName: "ใบเสร็จลูกค้า",
    width: 80,
    align: "right",
    valueFormatter: ({ value }) => value != null ? numberFormat(value) : "-",
  },
  {
    field: "Total",
    headerName: "ยอดรวม",
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value != null ? numberFormat(value) : "-",
  },
]